module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tf-aaea08de295f296f0bba198b214831ae.svg";